import { render } from "./partial-global-error-interior.vue?vue&type=template&id=f73ff230&ts=true"
import script from "./partial-global-error-interior.vue?vue&type=script&lang=ts"
export * from "./partial-global-error-interior.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__